var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import styled from "styled-components";
import { N40 } from "@atlaskit/theme/dist/esm/colors";
import { MicrosDeploymentStatus, } from "../../../__generated__/graphql-global-types";
export var Divider = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  background: ", ";\n  height: 1px;\n  margin-top: 1em;\n"], ["\n  width: 100%;\n  background: ", ";\n  height: 1px;\n  margin-top: 1em;\n"])), N40);
export var capitalizeWord = function (word) {
    return word ? word.charAt(0).toUpperCase() + word.toLowerCase().slice(1) : "";
};
export var updateURLParams = function (paramsString, newParams) {
    var urlParams = new URLSearchParams(paramsString);
    for (var _i = 0, newParams_1 = newParams; _i < newParams_1.length; _i++) {
        var param = newParams_1[_i];
        if (param.val) {
            urlParams.set(param.name, param.val);
        }
        else {
            urlParams.delete(param.name);
        }
    }
    return "?" + urlParams.toString();
};
export var getDeploymentId = function (id) {
    try {
        if (!id) {
            return "";
        }
        var parts = id.split("/");
        var _a = parts[parts.length - 1].split("--"), deploymentId = _a[2];
        return deploymentId;
    }
    catch (e) {
        throw new Error("Failed to get DeploymentId from MicrosServiceDeployment.id: " + id + ". " + e);
    }
};
export var getServiceId = function (id) {
    try {
        if (!id) {
            return "";
        }
        var parts = id.split("/");
        var service = parts[parts.length - 1].split("--")[0];
        return service;
    }
    catch (e) {
        throw new Error("Failed to get ServiceId from MicrosServiceDeployment.id: " + id + ". " + e);
    }
};
export var getEnv = function (id) {
    try {
        if (!id) {
            return "";
        }
        var parts = id.split("/");
        var _a = parts[parts.length - 1].split("--"), env = _a[1];
        return env;
    }
    catch (e) {
        throw new Error("Failed to get Env from MicrosServiceDeployment.id: " + id + ". " + e);
    }
};
export var deploymentStatus = function (status) {
    if (status === null || status === void 0 ? void 0 : status.toString().includes("COMPLETE")) {
        return "success";
    }
    else if (status === null || status === void 0 ? void 0 : status.toString().includes("FAILED")) {
        return "removed";
    }
    else {
        return "inprogress";
    }
};
// getInstances retrieves EC2 instances from query response.
export var getInstances = function (data, deploymentId, deploymentType) {
    var _a;
    if (!data || !data.service) {
        return [];
    }
    var shards = (_a = data.service.microsV2) === null || _a === void 0 ? void 0 : _a.shards;
    if (!shards || shards.length === 0) {
        return [];
    }
    // Find the shard and deployment that has the same deployment ID.
    var dep;
    var shard = shards.find(function (shard) {
        return (shard === null || shard === void 0 ? void 0 : shard.environments).items.find(function (item) {
            if (!item.deployments || !item.deployments[deploymentType]) {
                return undefined;
            }
            // Handle the different types of deployments.
            if (deploymentType === "persistent" || deploymentType === "other") {
                // Persistent and Other deploymentTypes can have multiple deployments.
                // Find the single deployment that matches.
                dep = item.deployments[deploymentType].find(function (deployment) {
                    return deploymentId.includes(deployment.id);
                });
                return dep;
            }
            else {
                // Stable, Previous, and Canary deploymentTypes have a single deployment.
                if (item.deployments[deploymentType].id ===
                    deploymentId) {
                    dep = item.deployments[deploymentType];
                    return dep;
                }
                else {
                    return undefined;
                }
            }
        });
    });
    if (!shard || !dep) {
        return [];
    }
    // Get all of the scalingGroups, reduce their instances, and return them.
    var scalingGroups = dep.serviceType.scalingGroups;
    if (!scalingGroups) {
        return [];
    }
    return scalingGroups.reduce(function (acc, curr) {
        var _a;
        return __spreadArrays(acc, (((_a = curr.instances) === null || _a === void 0 ? void 0 : _a.map(function (instance) { return (__assign({ groupName: curr.groupName }, instance)); })) || []));
    }, []);
};
export var sshProxyUrls = new Map([
    ["pdev-apse2", "micros-iam-manager.platdev.atl-paas.net"],
    ["dev-west2", "micros-iam-manager.dev.atl-paas.net"],
    ["ddev", "micros-iam-manager.dev.atl-paas.net"],
    ["adev", "micros-iam-manager.dev.atl-paas.net"],
    ["adev-west2", "micros-iam-manager.dev.atl-paas.net"],
]);
export var completeStatuses = [
    MicrosDeploymentStatus.CREATE_COMPLETE,
    MicrosDeploymentStatus.UPDATE_COMPLETE,
    MicrosDeploymentStatus.IMPORT_COMPLETE,
    MicrosDeploymentStatus.UPDATE_ROLLBACK_COMPLETE,
    MicrosDeploymentStatus.IMPORT_ROLLBACK_COMPLETE,
];
export var isDeploymentComplete = function (deploymentStatus) {
    return deploymentStatus ? completeStatuses.includes(deploymentStatus) : false;
};
var templateObject_1;
